<template>
  <div class="d-flex flex-column align-center justify-center pt-12">
    <h1>Result</h1>
    <p class="mt-5">First name: {{result.firstName}}</p>
    <p>Last name: {{result.lastName}}</p>
    <p>Result: {{result.result}}</p>
    <p>Case code: {{result.caseCode}}</p>
    <p>Result date: {{date(result.updatedAt)}}</p>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
  created() {
    axios
      .get(
        `${process.env.VUE_APP_BASE_URL}/search/case/code/${this.$route.params.caseCode}`
      )
      .then(res => {
        console.log(res);
        this.result = res.data;
      })
      .catch(err => {
        console.log(err);
      });
  },

  data() {
    return {
      result: null
    };
  },

  methods: {
    date(date) {
      return moment(new Date(date))
        .local()
        .format("DD/MM/YYYY");
    }
  }
};
</script>

g3n3r4t0r